<template>
  <div>
    <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

    <h4 qid="maintenance-create-rr-title">
      {{$t('maintenance.frameworks.create.title')}}
    </h4>

    <div class="card">
      <div class="card-body">
        <div class="form-centered">
          <b-alert v-if="error.length"
                   show
                   variant="danger"
                   qid="create-rr-error"
          >
            {{ error }}
          </b-alert>
          <b-form @submit="formSubmit" qid="create-rr-form">
            <div class="form-container">
              <b-form-group>
                <label qid="create-rr-name-label">
                  {{ $t('maintenance.frameworks.create.name_label') }}
                </label>
                <b-form-input
                  qid="create-rr-form-name"
                  type="text"
                  v-model="rrForm.name"
                  required
                  :maxLength="255"
                  :placeholder="$t('maintenance.frameworks.create.name_placeholder')"
                ></b-form-input>
              </b-form-group>
              <b-form-group>
                <label qid="create-rr-description-label">
                  {{ $t('maintenance.frameworks.create.description_label') }}
                </label>
                <b-form-textarea
                  qid="create-rr-form-description"
                  v-model="rrForm.description"
                  rows="6"
                  max-rows="6"
                  :placeholder="$t('maintenance.frameworks.create.description_placeholder')"
                ></b-form-textarea>
              </b-form-group>
              <b-form-group>
                <label qid="create-tp-attachments-label">
                  {{ $t('maintenance.frameworks.create.attachments') }}
                  &nbsp;
                  <span class="text-muted">({{ $t('attachments.file_size_label') }})</span>
                </label>
                <br>
                <p v-for="file in getFiles" :key="file.name">{{ file.name }}</p>
                <label class="btn btn-secondary cursor-pointer" qid="create-tp-attachments-button">
                  <input type="file"
                         name="fileupload"
                         value="fileupload"
                         multiple
                         id="file"
                         @change="onFileChange"
                         @click="resetFile"
                  >
                  <span>
                    <font-awesome-icon icon="cloud-upload-alt" />
                    {{ $t('system.upload') }}
                  </span>
                </label>
              </b-form-group>
            </div>
            <div class="text-right">
              <b-button class="mt-3"
                        variant="secondary"
                        @click="goToList"
                        qid="create-rr-cancel-button"
              >
                {{ $t('maintenance.frameworks.create.cancel') }}
              </b-button>
              <b-button type="submit"
                        class="mt-3 ml-3"
                        variant="success"
                        :disabled="buttonDisabled"
                        qid="create-rr-submit-button"
              >
                <span v-if="buttonDisabled" class="mr-1">
                  <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                </span>
                {{ $t('maintenance.frameworks.create.submit') }}
              </b-button>
            </div>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Datepicker from 'vuejs-datepicker';

  export default {
    name: 'CreateFramework',
    data: function() {
      return {
        breadcrumbItems: [
          {
            text: this.$t('dashboard.title'),
            to: '/'
          },
          {
            text: this.$t('maintenance.title'),
            to: '/maintenance'
          },
          {
            text: this.$t('maintenance.frameworks.title'),
            to: '/maintenance/frameworks'
          },
          {
            text: this.$t('maintenance.frameworks.create.title'),
            active: true
          }
        ],
        rrForm: {
          name: '',
          description: '',
          client:'',
        },
        error: '',
        inputLink: '',
        selectedFiles: [],
        timeLimitItems: [],
        timeLimitInput: '',
        buttonDisabled: false
      }
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getFiles() {
        return this.selectedFiles
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {
      }
    },
    methods: {
      goToList() {
        this.$router.push('/maintenance/frameworks')
      },
      resetFile() {
        let imagefile = document.querySelector('#file');
        imagefile.value = '';
      },
      onFileChange() {
        let files = document.querySelector('#file');
        // in order for v-for to re render, we need to set array to empty
        this.selectedFiles = [];
        // And then push item by item into that array
        for (var i = 0; i < files.files.length; i++) {
          this.selectedFiles.push(files.files[i])
        }
      },
      formSubmit(evt) {
        let formData = new FormData();
        let files = document.querySelector('#file');
        let sizeError = false;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        formData.append("name", this.rrForm.name);
        formData.append("description", this.rrForm.description);
        formData.append("client", this.getClient.slug);

        // Append list of attachments to FormData
        for (var i = 0; i < files.files.length; i++) {
          // Equal to 10 MB
          if (files.files[i].size > 10485760) {
            sizeError = true;
          }
          formData.append("files[]", files.files[i]);
        }

        if (sizeError) {
          this.error = this.$t('system.file_size')
        } else {
          this.buttonDisabled = true;
          // Post FormData object to API
          piincHttp.post('/frameworks', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function(response) {
            self.$toastr('success', self.$t('maintenance.frameworks.create.success'))
            self.buttonDisabled = false;
            self.goToList();
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
              if (error.data.errors['files.0']) {
                self.error += ' ' + error.data.errors['files.0'][0]
              }
            }
          })
        }
      },
    },
    components: {

    },
    created () {
      if (this.getClient && this.getClient.slug) {
      }
    }
  }
</script>
